/**
 * Plays muted, looping videos marked with data-autoplay-on-view while they are on
 * screen and pauses them when they leave it. Visitors who ask for reduced motion get the
 * native controls instead, so nothing moves unless they press play.
 * Loaded by several sections; runs once per page.
 */
(function () {
  if (window.__videoAutoplayOnView) return;
  window.__videoAutoplayOnView = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(video) {
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              video.__inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
              if (video.__inView) {
                play(video);
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.5, 1] }
        )
      : null;

  // A play() call made before the video has data can be dropped, so try again once it can play.
  function retryWhenReady(event) {
    var video = event.target;
    if (video.__inView && video.paused) play(video);
  }

  function setup(root) {
    (root || document).querySelectorAll('video[data-autoplay-on-view]:not([data-autoplay-on-view="false"])').forEach(function (video) {
      if (video.dataset.autoplayReady) return;
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      if (reduceMotion || !observer) {
        video.controls = true;
        return;
      }
      video.addEventListener('canplay', retryWhenReady);
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
    });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
